import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CLIENTS_LIST_KEY } from 'modules/crm/clients/constants';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { UserAdminService } from 'modules/security/users/services';

export const useDeleteClients = (id: string, onClose: () => void) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('clients');

  return useMutation(() => UserAdminService.delete(id), {
    onSuccess: () => {
      toast.success(t('successDeleted'));
      onClose?.();

      queryClient.invalidateQueries({ queryKey: [CLIENTS_LIST_KEY] });
      queryClient.invalidateQueries({ queryKey: [id] });
    },
  });
};
